<template>
  <ChecklistItem
    title="1. Set up your profile"
    description="Let the world know who you are"
    :is-done="isDone"
    :editing="editing"
    @edit="startEdit"
    @done="saveProfile"
  >
    <template #default>
      <iColumn gap="standard" width="fill">
        <iTextInput
          v-model="name"
          label="Organization Name"
          width="fill"
        />
        <iTextInput
          v-model="description"
          label="Description"
          width="fill"
        />
      </iColumn>
    </template>
    <template #pitch>
      <iText font-size="standard">
        Add your name and description so clients can get to know you.
      </iText>
    </template>
    <template #summary>
      <iColumn gap="none" width="fill">
        <iText font-size="standard">
          {{ name }}
        </iText>
        <iText variant="subtle" font-size="small">
          {{ description }}
        </iText>
      </iColumn>
    </template>
  </ChecklistItem>
</template>

<script>
import { mapActions, mapState } from "pinia";
import ChecklistItem from "@/components/onboarding/ChecklistItem.vue";
import { useOrganizationStore } from "@/stores/organization-store";

export default {
  name: "ProfileChecklist",
  components: { ChecklistItem },
  data() {
    return {
      editing: false,
      name: this.orgName,
      description: this.orgDescription,
    };
  },
  computed: {
    ...mapState(useOrganizationStore, ["orgName", "orgDescription", "isLoadingUpdateOrgName", "isLoadingUpdateOrgDescription"]),
    isDone() {
      return !!this.orgName && !!this.orgDescription;
    },
  },
  methods: {
    ...mapActions(useOrganizationStore, ["updateOrgName", "updateOrgDescription"]),
    startEdit() {
      this.name = this.orgName;
      this.description = this.orgDescription;
      this.editing = true;
    },
    saveProfile() {
      this.updateOrgName(this.name);
      this.updateOrgDescription(this.description);
      this.editing = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
